module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Discrepancy Codes * </label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=select-discrepancy-codes> <select class=\"select2-select q-input stretch\" data-minimum-results-for-search=Infinity data-error-placement-append-closest=div style=width:100% data-placeholder=\"Enter Discrepancy Codes\"> <option></option> {%= DiscrepancyCodesDropDown %} <select> </select></select></div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/receivingDiscrepancies/html/manageDiscrepancyCodes.html
// module id = 1393
// module chunks = 1